export enum PurchasableItemContentType {
    COINS = 'COINS',
    LOOT_BOX = 'LOOT_BOX',
}